module.exports = __webpack_public_path__ + "img/rz2.8f7712f0.jpeg";